import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ATA.PARTES_ENVOLVIDAS.SET_LISTAGEM](state, dados) {
		state.listagem = {
			itens: dados?.itens || [],
			totalItens: dados?.totalElements || 0,
			totalPaginas: dados?.totalPages || 0,
		}
	},

	[mutationTypes.ATA.PARTES_ENVOLVIDAS.LIMPAR_LISTAGEM](state) {
		state.listagem = {
			itens: [],
			totalItens: 0,
			totalPaginas: 0,
		}
	},
}
